import React from 'react';

import { isEmpty } from 'ramda';

import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import IllustrationMap from 'components/shared/Icon/icons/IllustrationMap';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import ActionsMenu from '../ActionsMenu';
import { Day } from './Day';
import { useActiveTripEventModal, useChronologicalMode, useAddEventMenuActions } from './functions';
import s from './index.module.css';
import { useTimelineContext } from './TimelineContext';

export const Timeline = () => {
  useActiveTripEventModal();

  const { timelineDays } = useTimelineContext();
  const { nextDayToCreate } = useChronologicalMode();
  const addEventMenuActions = useAddEventMenuActions(nextDayToCreate);
  const { isTabletOrMobile } = useMediaBreakpoints();

  if (timelineDays === null || isEmpty(timelineDays)) {
    return (
      <div className={s.empty}>
        <Icon width="128" height="128" className={s.emptyIcon} component={IllustrationMap} />

        <div className={s.emptyContent}>
          <div className={s.emptyTitle}>Start by Adding an Event</div>
          <p className={s.emptyText}>
            To add events, hover over a day on the Calendar and click the plus icon. Manage your events from here on the
            Timeline View or directly within the Calendar.
          </p>
        </div>

        {!isTabletOrMobile && (
          <ActionsMenu actions={addEventMenuActions}>
            <Button type="primary2" size="medium" className={s.emptyButton}>
              Add Event
            </Button>
          </ActionsMenu>
        )}
      </div>
    );
  }

  return (
    <div id="timeline">
      {timelineDays.map((day) => (
        <Day key={day.day} day={day} />
      ))}
    </div>
  );
};
